import { useActiveLegalDocument } from '@/hooks/useLegalDocuments';
import { LegalPageLayout } from '@/components/legal/LegalPageLayout';
import { Loader2 } from 'lucide-react';
import { format } from 'date-fns';

export default function POTerms() {
  const { data: document, isLoading } = useActiveLegalDocument('po-terms');

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!document) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-muted-foreground">Document not available.</p>
      </div>
    );
  }

  return (
    <LegalPageLayout
      title={document.title}
      metadata={{
        version: document.version,
        effectiveDate: document.effective_date 
          ? format(new Date(document.effective_date + 'T12:00:00'), 'MMMM d, yyyy')
          : undefined,
      }}
      content={document.content}
      seoDescription="Radius Purchase Order Terms and Conditions governing procurement transactions between Buyers and Vendors on the Radius Platform."
      canonicalPath="/po-terms"
    />
  );
}
